/** Jours saisissables sur les lignes honoraires / banques (U3129 / U3130). */
const WEEK_DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"] as const;

function dayHours(value: unknown): number {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

/** Somme lundi–dimanche sur une ligne banque ou honoraire. */
export function u2000SumWeekHoursOnTimesheetBankRow(row: Record<string, unknown> | undefined | null): number {
  if (!row) {
    return 0;
  }
  return WEEK_DAYS.reduce((sum, day) => sum + dayHours(row[day]), 0);
}

/**
 * Total heures sur **toutes** les lignes banques d’heures (vacances, férié, maladie, congé autorisé, banque spéciale).
 * Affichage : Total projet = honoraires projets ; totaux absence/banques = somme de toutes les lignes banque.
 */
export function u2000SumAllBankHoursFromTimesheetBankList(list: readonly Record<string, unknown>[] | undefined | null): number {
  return (list ?? []).reduce((sum, row) => sum + u2000SumWeekHoursOnTimesheetBankRow(row), 0);
}
